import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { OrderLineDetail } from 'app/core/model/entity-model';
import moment from 'moment';
import { AuthService, EntitiesService, GenesisUnitOfWork, UtilityService } from '../../core/core.module';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-status-review',
    templateUrl: './status-review.component.html',
    styleUrls: ['./status-review.component.scss'],
    standalone: false
})
export class StatusReviewComponent implements OnInit {
    orderLineDetails: OrderLineDetail[];

    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private auth: AuthService,
        protected location: Location,
        private entitiesService: EntitiesService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.orderLineDetails = await this.uow.getBuiltAndNoBuiltDateOrderLineDetails();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async updateInventory(orderLineDetails: OrderLineDetail[]) {
        for (let index = 0; index < orderLineDetails.length; index++) {
            await this.utility.updateInventory(orderLineDetails[index].id);
            this.entitiesService.createOrderLineDetailNote(orderLineDetails[index].id, `Status Review - Marked as Built`, this.auth.currentUser.id);
        }
        await this.uow.commit();
        await this.getData();
    }

    async doNotUpdateInventory(orderLineDetails: OrderLineDetail[]) {
        for (let index = 0; index < orderLineDetails.length; index++) {
            orderLineDetails[index].built = moment(new Date()).toDate();
            orderLineDetails[index].processed = 3;

            this.entitiesService.createOrderLineDetailNote(orderLineDetails[index].id, `Manually Entered Built Date`, this.auth.currentUser.id);
        }
        await this.uow.commit();
        await this.getData();
    }
}
